<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Außenfühler"}}</h4>
</div>
<div class="modal-body schema-dialog-body">
	<div id="error-msg" class="alert alert-danger invisible"></div>
	<div class="row">
		<div class="col-xs-2">
			<button type="button" id="js-minus" class="btn btn-white m-t-20">
				<i class="fa fa-minus"></i>
			</button>
		</div>
		<div class="col-xs-8">
			<div class="slider slider-primary m-t-15 m-b-15">
				<input type="text" id="js-slider" data-plugin="range-slider" data-slider-orientation="horizontal" data-slider-min="0" data-slider-max="401" data-slider-value="{{value}}">
			</div>
		</div>
		<div class="col-xs-2">
			<button type="button" id="js-plus" class="btn btn-white pull-right m-t-20">
				<i class="fa fa-plus"></i>
			</button>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-save">{{TR "Speichern"}}</button>
</div>
